export enum RequestMethod {
    Get = "get",
    Post = "post",
    Patch = "patch",
    Delete = "delete",
}
